import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SerializedSocialChannel } from '../types';
import { channelBestSlot } from './channelBestSlot';
import { ChannelNumbersState } from './channelNumbersState';
import { followersLabelMessage } from './channelNumbersMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import shared from '../Promote.module.scss';
import styles from './PromoteChannels.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ChannelNumbersProps {
  channel: SerializedSocialChannel;
  state: ChannelNumbersState;
  /** The read stopped (X on a plan without X): the last numbers stay, grey. */
  dim?: boolean;
}

/** The two numbers of the card: the followers (subscribers on YouTube) and the best slot. */
const ChannelNumbersComponent: React.FC<ChannelNumbersProps> = ({ channel, state, dim = false }) => {
  const intl = useIntl();
  // Only a channel with a read, or with numbers from before the sign-in ended, has a count.
  const hasCount = (state === 'numbers' || state === 'reconnect') && channel.followers !== null;

  return (
    <div className={styles.stats}>
      <div>
        <div className={styles.statLabel}>{intl.formatMessage(followersLabelMessage(channel.platform))}</div>
        <div
          className={clsx(styles.followers, (state === 'reconnect' || dim) && styles.followersOld)}
          data-testid="channel-followers"
        >
          {hasCount && channel.followers !== null ? (
            intl.formatNumber(channel.followers)
          ) : (
            // A number that the platform does not give is a dash, never 0.
            <span className={shared.dash}>—</span>
          )}
        </div>
      </div>
      <div>
        <div className={styles.statLabel}>
          {intl.formatMessage({ id: 'app.sml.promote.channel.bestSlot', defaultMessage: 'Best slot' })}
        </div>
        <div className={styles.statValue}>{channelBestSlot(intl, channel)}</div>
      </div>
    </div>
  );
};

export const ChannelNumbers = TypedMemo(ChannelNumbersComponent);
